import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { GenericSelectMultiple } from '../../components';


const ExclusionClausesInput: InputWithSource = ({ input }) => (
    <GenericSelectMultiple label={input.name} input={input} />
);

ExclusionClausesInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(ExclusionClausesInput);
